import React, { ComponentPropsWithoutRef, ReactNode } from "react";

import { Modal } from "../modal";
import { Dialog, DialogContent, DialogFooter, DialogTitle } from "./dialog";

export const SimpleDialog = ({
	title,
	contentHtml,
	footer,
	className,
	fullScreen,
	children,
	onCloseIcon,
	...modalProps
}: React.PropsWithChildren<{
	title?: ReactNode;
	contentHtml?: string;
	footer?: ReactNode;
}> &
	ComponentPropsWithoutRef<typeof Modal> &
	ComponentPropsWithoutRef<typeof Dialog>) => {
	const Title = () => (title ? <DialogTitle>{title}</DialogTitle> : null);

	const Content = () =>
		children || contentHtml ? (
			<DialogContent html={contentHtml}>{children}</DialogContent>
		) : null;

	const Footer = () => (footer ? <DialogFooter>{footer}</DialogFooter> : null);

	return (
		<Modal {...modalProps}>
			<Dialog className={className} fullScreen={fullScreen} onCloseIcon={onCloseIcon}>
				<Title />
				<Content />
				<Footer />
			</Dialog>
		</Modal>
	);
};
SimpleDialog.displayName = "SimpleDialog";
